import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import Footer from './footer';

class SideNav extends Component {
  constructor(props){
    super(props);
    this.state = {
      results: ''
    }

    this.getNavigation = this.getNavigation.bind(this);
  }
  componentWillMount(){
    this.getNavigation();
  }

  componentWillReceiveProps(newProps){
    if(this.props === newProps) {return;}
    this.props = newProps;
  }

  getNavigation() {
    const apiUrl = `${window.location.protocol}//${window.location.host}/api/navigation/wdelite`;
    fetch(apiUrl)
    .then(res => {
      return res.json();
    })
    .then(json => {

      let options = _.chain(json)
      .sortBy('section.sectionOrder')
      .groupBy('section.title')
      .map((value, key) => {
        //this is an array of groups
        //each group is an array of docs
        //map the groups into unordered lists
        const sorted = _.sortBy(value, 'document.documentOrder');
        return (
          <ul className="links">
            <li className="heading">{sorted[0].section.title}</li>
            {
              sorted.map((d, idx) => {
                const url = d.document.key.split(':');
                return <li>
                  <NavLink 
                    to={`/${url[0]}/${url[1]}/${url[2]}`} 
                    activeClassName="nav-item-active">{d.document.title}
                  </NavLink>
                </li>
              })
            }
          </ul>
        )
      })
      .value();

      this.setState({results: options});

    });
  }

  render(){
    return (
      <div className="sidenav">
        <div className="sidenav-content">
          <div className="nav-items">
            {(!this.props.isAuthenticated) && this.state.results}
            {(this.props.isAuthenticated) && 
            <div>
              <ul className="links links-admin">
                <li className="heading">Administration</li>
                <li><NavLink activeClassName="nav-item-active" to="/admin/editor">Content Editor</NavLink></li>
              </ul> 
            </div>
            }
          </div>
          <Footer /> 
        </div>
      </div>
    );
  }
}

export default SideNav;
